// @ts-nocheck
import React, { useState } from 'react';
import { useQuery } from 'convex/react';
import { api } from '@/convex/_generated/api';
import { Id } from '@/convex/_generated/dataModel';
import { formatDistanceToNow } from 'date-fns';
import { ChevronDown, ChevronUp, Wallet, User } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PostTipHistoryProps {
	contentHistoryId: Id<'contentHistory'>;
}

export function PostTipHistory({ contentHistoryId }: PostTipHistoryProps) {
	const [isExpanded, setIsExpanded] = useState(false);

	// Query recent tip transactions for this post
	const recentTips = useQuery(api.tipAnalytics.getRecentTipTransactions, {
		contentHistoryId,
		limit: 10,
	});

	// Don't render if no tips
	if (!recentTips || recentTips.length === 0) {
		return null;
	}

	const formatKarmaAmount = (amount: string) => {
		const num = parseFloat(amount);
		if (num >= 1000) {
			return `${(num / 1000).toFixed(1)}K`;
		}
		return num.toFixed(2);
	};

	const displayedTips = isExpanded ? recentTips : recentTips.slice(0, 3);

	return (
		<div className='mt-4 pt-4 border-t border-gray-600/20'>
			<div className='flex items-center justify-between mb-3'>
				<div className='flex items-center gap-2'>
					<Wallet className='h-4 w-4 text-yellow-400' />
					<span className='text-sm font-medium text-gray-300'>
						Recent Earnings ({recentTips.length})
					</span>
				</div>
				{recentTips.length > 3 && (
					<Button
						variant='ghost'
						size='sm'
						onClick={() => setIsExpanded(!isExpanded)}
						className='p-1 h-auto text-gray-400 hover:text-gray-200'
					>
						{isExpanded ? (
							<ChevronUp className='h-4 w-4' />
						) : (
							<ChevronDown className='h-4 w-4' />
						)}
					</Button>
				)}
			</div>

			<div className='space-y-2'>
				{displayedTips.map((tip) => (
					<div
						key={tip._id}
						className='flex items-center justify-between p-2 rounded-lg bg-gray-800/50 border border-gray-700/30'
					>
						<div className='flex items-center gap-3'>
							<div className='flex items-center gap-2'>
								<User className='h-3 w-3 text-gray-400' />
								<span className='text-sm font-medium text-white'>
									{tip.senderName}
								</span>
							</div>
							<span className='text-xs text-gray-400'>
								{formatDistanceToNow(new Date(tip.timestamp), {
									addSuffix: true,
								})}
							</span>
						</div>

						<div className='flex items-center gap-1'>
							<span className='text-sm font-semibold text-yellow-400'>
								{formatKarmaAmount(tip.amount)} KARMA
							</span>
						</div>
					</div>
				))}
			</div>

			{recentTips.length > 3 && !isExpanded && (
				<div className='mt-2 text-center'>
					<Button
						variant='ghost'
						size='sm'
						onClick={() => setIsExpanded(true)}
						className='text-xs text-gray-400 hover:text-gray-200 p-1 h-auto'
					>
						View {recentTips.length - 3} more tips...
					</Button>
				</div>
			)}
		</div>
	);
}
